// import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "assets/styles/main.scss";
import { BrowserRouter } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import RouterComponent from "routes";
import "react-toastify/dist/ReactToastify.css";
import { PortalWithState } from "react-portal";
import { OfflineTopBarNotification } from "./components";
import { useEffect } from "react";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 0,
      gcTime: 0,
      refetchOnWindowFocus: false,
      retry: (failureCount, error: any) => {
        if (!navigator.onLine) {
          return false; // Nie retry offline
        }
        return failureCount < 3;
      },
      // ✅ KLUCZOWA ZMIANA - retry od razu po powrocie online
      retryOnMount: true,
      refetchOnReconnect: true,
      // ✅ Network mode - będzie używać cache gdy offline
      networkMode: "offlineFirst",
    },
    mutations: {
      retry: (failureCount, error: any) => {
        if (!navigator.onLine) {
          return false;
        }
        return failureCount < 3;
      },
      networkMode: "online",
    },
  },
});

function App() {
  useEffect(() => {
    if (process.env.NODE_ENV === "development" && navigator.onLine) {
      caches.keys().then((names) => {
        names.forEach((name) => {
          if (name.startsWith("som-martdom")) {
            console.log("Clearing cache:", name);
            caches.delete(name);
          }
        });
      });
    }
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <div className="app">
        <OfflineTopBarNotification />
        <BrowserRouter>
          <RouterComponent />
        </BrowserRouter>
        {/* <ReactQueryDevtools initialIsOpen={false} /> */}
        <PortalWithState
          closeOnEsc={true}
          closeOnOutsideClick={false}
          defaultOpen={true}
        >
          {({ portal }) => (
            <div className="toast__wrapper">
              {portal(
                <ToastContainer
                  stacked
                  position="bottom-right"
                  autoClose={3000}
                  newestOnTop={false}
                  closeOnClick
                  rtl={false}
                  pauseOnFocusLoss
                  draggable
                  pauseOnHover
                  theme="light"
                />
              )}
            </div>
          )}
        </PortalWithState>
      </div>
    </QueryClientProvider>
  );
}

export default App;
